import React from "react";

export default function renderIcon({
  width = 21,
  height = 21,
  color = "#9ca2b8",
}) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.2369 15.8792C29.2369 8.49979 23.2478 2.51074 15.8684 2.51074C8.48906 2.51074 2.5 8.49979 2.5 15.8792C2.5 22.3495 7.09874 27.7369 13.1947 28.9802V19.8897H10.5211V15.8792H13.1947V12.5371C13.1947 9.95695 15.2936 7.85811 17.8737 7.85811H21.2158V11.8686H18.5421C17.8068 11.8686 17.2053 12.4702 17.2053 13.2055V15.8792H21.2158V19.8897H17.2053V29.1807C23.9563 28.5123 29.2369 22.8174 29.2369 15.8792Z"
        fill="#FFFFFF"
      />
    </svg>
  );
}
